import { useSelector, useDispatch } from 'react-redux';
import {
  selectCurrentFloorplan,
  selectSuggestedCalibration,
} from 'spw-redux/modules/floorplan/selectors';
import { useCallback, useEffect, useMemo, useRef } from 'react';
import { fetchSuggestedCalibration } from 'spw-redux/modules/floorplan/actions';
import { selectCurrentOrganization } from 'spw-redux/modules/organization/selectors';

export const SUGGESTED_CALIBRATION_LINE_STATUS = {
  IN_PROGRESS: 'in_progress',
  DONE: 'done',
  FAILED: 'failed',
};

export const usePollSuggestedCalibrationLine = () => {
  const suggestedCalibration = useSelector(selectSuggestedCalibration);
  const floorplan = useSelector(selectCurrentFloorplan);
  const organization = useSelector(selectCurrentOrganization);
  const delay = 1000;
  const dispatch = useDispatch();

  const callbackRef = useRef<ReturnType<typeof setTimeout>>();

  const shouldKeepPolling = useMemo(() => {
    return (
      floorplan?.id &&
      organization?.hasAccessToAITools &&
      suggestedCalibration?.status ===
        SUGGESTED_CALIBRATION_LINE_STATUS.IN_PROGRESS
    );
  }, [floorplan?.id, organization?.hasAccessToAITools, suggestedCalibration]);

  const checkSuggestedCalibrationStatus = useCallback(() => {
    dispatch(fetchSuggestedCalibration());
  }, [dispatch]);

  useEffect(() => {
    if (shouldKeepPolling && !callbackRef.current) {
      callbackRef.current = setInterval(checkSuggestedCalibrationStatus, delay);
    } else if (!shouldKeepPolling && callbackRef.current) {
      clearInterval(callbackRef.current);
      callbackRef.current = null;
    }
    return () => {
      clearInterval(callbackRef.current);
      callbackRef.current = null;
    };
  }, [shouldKeepPolling, checkSuggestedCalibrationStatus]);

  return {
    calibrationStatus: suggestedCalibration?.status,
  };
};
